<template>
  <div class="i-user-multi-picker">

    <i-multi-picker
      ref="MultiPicker"
      label-counter="object(s)"
      :label="label"
      :value="value"
      :fetch-options="fetchObjects"
      option-label="objectLabel"
      option-value="id"
      @input="$val => $emit('input',$val)"
    />
  </div>
</template>

<script>
import {listSnapshotDetails} from "@/services/api/app/salesforce/recovery/salesforceObject/data-set/file";
import IMultiPicker from "@/components/common/forms/IMultiPicker";

export default {
  name: 'IObjectMultiPicker',
  components: {IMultiPicker},
  props: {
    value: [],
    label: {
      type: String,
      default: 'Objects'
    },
    placeholder: {
      type: String,
      default: 'Search all objects'
    },
    snapshotId: {
      type: String
    },
  },

  data() {
    return {
      selected: null,
      objects: []
    }
  },

  methods: {
    fetchObjects({search}) {
      return listSnapshotDetails({
        pagination: {
          pageNumber: 1,
          pageSize: 30,
          sortBy: "objectName",
          sortDescending: false,
        },
        objectType: '1',
        searchTerm: search,
        snapshotId: this.snapshotId
      })
        .then(({result}) => {
          return result
        })
    },
  },

  watch: {
    snapshotId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.snapshotId = newVal;
        this.$refs.MultiPicker.onSearch(null);
      }
    }
  }
}
</script>

<style lang="scss">
@import "IUserMultiPicker.scss";
</style>
